<template>
    <div>
        <Header/>
            <div class="container">
            <SecondHeader/>
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <h2 class="title_section">Objetivo de desarrollo sostenible</h2>
                    </div>
                    <div class="col-md-6 col-sm-12 text-objetivos">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                    </div>
                    <div class="col-md-6 col-sm-12 text-objetivos">
                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <h2 class="title_section">Indicador(es) global(es) de los ODS al que contribuye</h2>
                    </div>
                    <div class="col-md-6 col-sm-12 text-objetivos">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                    </div>
                    <div class="col-md-6 col-sm-12 text-objetivos">
                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet numquam earum 
                        tempore odio aliquam. Ipsam iusto corporis libero. Praesentium 
                        aliquam commodi ipsum distinctio ab repellat deleniti magni quaerat magnam sed!
                    </div>
                </div>
            </div>
        <Footer/>
    </div>
</template>



<script>
import Header from "./partials/Header"
import SecondHeader from "./partials/SecondHeader"
import Footer from "./partials/Footer"

export default {
  components:{
      Header,
      SecondHeader,
      Footer,
  },
}
</script>


<style>
   .title_section{
        color: #3366CC;
        font-weight: bolder;
        margin-bottom: 20px;
    }
    .text-objetivos{
        text-align: justify;
    }
    .container > .row:nth-child(2n), .container > .row:nth-child(3n) {
        margin-bottom: 40px;
    }    
</style>
